import { htmlToPlainText } from '@heidi/utils/html-to-plain-text';

export function getPlainPartnerDisplaySummary(
  displaySummary: string | null | undefined
): string | undefined {
  if (!displaySummary) return undefined;
  const plain = htmlToPlainText(displaySummary);
  return plain || undefined;
}

/** EVI-1570: partner sources use plain display_summary; others keep snippet/citedText. */
export function resolvePartnerSourceSnippetText(params: {
  displaySummary?: string | null;
  isPartnerSource: boolean;
  fallbackSnippet?: string | null;
}): string | undefined {
  if (params.displaySummary) {
    return getPlainPartnerDisplaySummary(params.displaySummary);
  }
  if (params.isPartnerSource) return undefined;
  return params.fallbackSnippet ?? undefined;
}
